/**
 * Journey marker defaults + breakpoint helpers (Dashboard V2 My Goals only).
 *
 * Tune with Journey Dev Mode (drag markers and/or draw trail), then paste
 * exported JSON back into JOURNEY_POINTS_BY_BREAKPOINT /
 * JOURNEY_PATH_SAMPLES_BY_BREAKPOINT below.
 */

export const JOURNEY_BREAKPOINTS = {
    desktop: { id: 'desktop', minWidth: 1200, label: 'Desktop / laptop (≥1200px)' },
    tablet: { id: 'tablet', minWidth: 768, label: 'Tablet (768–1199px)' },
    mobile: { id: 'mobile', minWidth: 0, label: 'Mobile (≤767px)' },
};

/** Defaults per viewport — path + markers share these coords when no samples. */
export const JOURNEY_POINTS_BY_BREAKPOINT = {
    desktop: [
        { rank: 1, type: 'oolaOne', x: 48.2, y: 12.5, side: 'right' },
        { rank: 2, x: 48.1, y: 32.8, side: 'left' },
        { rank: 3, x: 51.5, y: 45.6, side: 'left' },
        { rank: 4, x: 46.4, y: 58.4, side: 'right' },
        { rank: 5, x: 36.3, y: 66.1, side: 'right' },
        { rank: 6, x: 42.6, y: 81.5, side: 'left' },
        { rank: 7, x: 41, y: 93.5, side: 'right' },
    ],
    tablet: [
        { rank: 1, type: 'oolaOne', x: 52, y: 25, side: 'right' },
        { rank: 2, x: 61, y: 38, side: 'left' },
        { rank: 3, x: 54, y: 49, side: 'left' },
        { rank: 4, x: 45, y: 58, side: 'right' },
        { rank: 5, x: 36, y: 67, side: 'right' },
        { rank: 6, x: 40, y: 78, side: 'left' },
        { rank: 7, x: 31, y: 86, side: 'right' },
    ],
    mobile: [
        { rank: 1, type: 'oolaOne', x: 49.1, y: 16, side: 'right' },
        { rank: 2, x: 49.1, y: 32.7, side: 'left' },
        { rank: 3, x: 45.9, y: 48, side: 'left' },
        { rank: 4, x: 23, y: 57, side: 'right' },
        { rank: 5, x: 43.5, y: 67.5, side: 'right' },
        { rank: 6, x: 65.1, y: 75.3, side: 'left' },
        { rank: 7, x: 43.4, y: 79, side: 'right' },
    ],
};

/**
 * Optional freehand trail samples (trailhead → summit) per breakpoint.
 * When present, the SVG path follows these instead of only the 7 markers.
 * null/[] = derive path from markers via Catmull-Rom.
 */
export const JOURNEY_PATH_SAMPLES_BY_BREAKPOINT = {
    desktop: [
        { x: 41.7, y: 93 },
        { x: 42.7, y: 92.2 },
        { x: 44.2, y: 92.6 },
        { x: 45, y: 92.4 },
        { x: 46.5, y: 92 },
        { x: 47.6, y: 91.9 },
        { x: 48.5, y: 91.3 },
        { x: 48.8, y: 90.8 },
        { x: 49, y: 89.7 },
        { x: 48.3, y: 88.2 },
        { x: 47, y: 86.6 },
        { x: 46.1, y: 85.7 },
        { x: 45.2, y: 84.6 },
        { x: 44, y: 83.3 },
        { x: 42.9, y: 81.6 },
        { x: 42, y: 80.4 },
        { x: 40.9, y: 79.3 },
        { x: 39.9, y: 77.8 },
        { x: 39.1, y: 76.3 },
        { x: 38.6, y: 75.1 },
        { x: 37.9, y: 73.8 },
        { x: 37.4, y: 72.9 },
        { x: 36.6, y: 70.5 },
        { x: 36.3, y: 69 },
        { x: 36.2, y: 67.2 },
        { x: 36.3, y: 65.9 },
        { x: 37.5, y: 64.8 },
        { x: 40.7, y: 63 },
        { x: 42.2, y: 62.3 },
        { x: 43.1, y: 61.5 },
        { x: 43.9, y: 60.8 },
        { x: 44.6, y: 60.1 },
        { x: 46, y: 58.6 },
        { x: 47.2, y: 58.2 },
        { x: 48.5, y: 57.9 },
        { x: 49.4, y: 55.9 },
        { x: 50.6, y: 53 },
        { x: 51.2, y: 51.3 },
        { x: 51.7, y: 48.9 },
        { x: 51.7, y: 47.3 },
        { x: 51.6, y: 44.9 },
        { x: 50.7, y: 43.5 },
        { x: 50.4, y: 41.8 },
        { x: 49.3, y: 40 },
        { x: 48.5, y: 38 },
        { x: 47.7, y: 36 },
        { x: 47.8, y: 34 },
        { x: 48.5, y: 31.9 },
        { x: 49.9, y: 28.7 },
        { x: 49.9, y: 28.1 },
        { x: 49.5, y: 26.5 },
        { x: 49.2, y: 25.5 },
        { x: 49, y: 24.6 },
        { x: 48.8, y: 23.2 },
        { x: 48.7, y: 22.4 },
        { x: 48.6, y: 20.3 },
        { x: 48.4, y: 19.2 },
        { x: 48.3, y: 17.9 },
    ],
    tablet: null,
    mobile: [
        { x: 43.4, y: 79 },
        { x: 44.6, y: 79 },
        { x: 49.9, y: 78.3 },
        { x: 51.1, y: 78 },
        { x: 51.9, y: 78 },
        { x: 55.1, y: 77.2 },
        { x: 57.4, y: 76.7 },
        { x: 59.4, y: 76.7 },
        { x: 62.4, y: 76.5 },
        { x: 64.2, y: 75.9 },
        { x: 65.7, y: 75.7 },
        { x: 63.9, y: 74.6 },
        { x: 62.7, y: 74 },
        { x: 61.2, y: 73.2 },
        { x: 57.1, y: 72.2 },
        { x: 55.6, y: 71.3 },
        { x: 53.9, y: 70.5 },
        { x: 51.4, y: 69.6 },
        { x: 50.1, y: 68.7 },
        { x: 47.6, y: 68.5 },
        { x: 43.9, y: 67.7 },
        { x: 42.1, y: 66.9 },
        { x: 40.6, y: 66 },
        { x: 36.8, y: 65 },
        { x: 35.8, y: 64.4 },
        { x: 33.8, y: 63.7 },
        { x: 30.6, y: 62.1 },
        { x: 29.3, y: 61.1 },
        { x: 26.8, y: 60.2 },
        { x: 24.6, y: 58.4 },
        { x: 23.3, y: 57.4 },
        { x: 22.3, y: 56.2 },
        { x: 21.6, y: 54.4 },
        { x: 23.1, y: 53 },
        { x: 25.6, y: 52.5 },
        { x: 31.1, y: 51.2 },
        { x: 31.8, y: 51.2 },
        { x: 33.8, y: 50.9 },
        { x: 37.3, y: 50.1 },
        { x: 39.3, y: 49.9 },
        { x: 41.4, y: 49.3 },
        { x: 45.4, y: 48.5 },
        { x: 46.1, y: 48.3 },
        { x: 46.6, y: 48.1 },
        { x: 50.6, y: 46.7 },
        { x: 52.9, y: 45.6 },
        { x: 54.6, y: 44.3 },
        { x: 56.6, y: 41.7 },
        { x: 57.4, y: 40.9 },
        { x: 58.1, y: 40 },
        { x: 56.6, y: 38.2 },
        { x: 54.4, y: 37.5 },
        { x: 53.6, y: 36.7 },
        { x: 51.1, y: 35.1 },
        { x: 49.9, y: 34 },
        { x: 49.1, y: 33.2 },
        { x: 49.6, y: 30 },
        { x: 50.9, y: 28.6 },
        { x: 51.9, y: 27.9 },
        { x: 52.6, y: 26.6 },
        { x: 52.4, y: 25.8 },
        { x: 51.6, y: 25.3 },
        { x: 50.1, y: 22.1 },
        { x: 49.6, y: 20.4 },
    ],
};

const DEV_FLAG_KEY = 'dv2JourneyDev';
const OVERRIDES_KEY = 'dv2JourneyOverridesV2';

export function isJourneyDevAvailable() {
    return process.env.NODE_ENV !== 'production';
}

export function readJourneyDevEnabled() {
    if (!isJourneyDevAvailable()) return false;
    try {
        if (typeof window === 'undefined') return false;
        if (window.__DV2_JOURNEY_DEV__ === true) return true;
        return window.localStorage?.getItem(DEV_FLAG_KEY) === '1';
    } catch {
        return false;
    }
}

export function writeJourneyDevEnabled(enabled) {
    if (!isJourneyDevAvailable()) return;
    try {
        if (enabled) {
            window.localStorage?.setItem(DEV_FLAG_KEY, '1');
            window.__DV2_JOURNEY_DEV__ = true;
        } else {
            window.localStorage?.removeItem(DEV_FLAG_KEY);
            window.__DV2_JOURNEY_DEV__ = false;
        }
    } catch {
        /* ignore */
    }
}

export function getBreakpointId(width) {
    const w = Number(width) || 0;
    if (w >= 1600) return 'desktop';
    if (w >= 1200) return 'desktop'; /* laptop mid still uses desktop path coords */
    if (w >= 768) return 'tablet';
    return 'mobile';
}

function clonePoints(points) {
    return (points || []).map((p) => ({ ...p }));
}

function cloneSamples(samples) {
    if (!Array.isArray(samples) || !samples.length) return null;
    return samples.map((p) => ({
        x: roundCoord(p.x),
        y: roundCoord(p.y),
    }));
}

function normalizePoints(points, fallback) {
    const base = clonePoints(fallback);
    if (!Array.isArray(points) || !points.length) return base;
    return base.map((def, i) => {
        const hit =
            points.find((p) => Number(p.rank) === Number(def.rank)) ||
            points[i];
        if (!hit) return { ...def };
        const x = Number(hit.x);
        const y = Number(hit.y);
        return {
            ...def,
            x: Number.isFinite(x) ? roundCoord(x) : def.x,
            y: Number.isFinite(y) ? roundCoord(y) : def.y,
            side:
                hit.side === 'left' || hit.side === 'right'
                    ? hit.side
                    : def.side,
        };
    });
}

export function roundCoord(n) {
    return Math.round(Number(n) * 10) / 10;
}

export function clampPercent(n) {
    const v = Number(n);
    if (!Number.isFinite(v)) return 0;
    return Math.min(100, Math.max(0, roundCoord(v)));
}

export function getDefaultPoints(breakpointId) {
    const id = JOURNEY_BREAKPOINTS[breakpointId] ? breakpointId : 'desktop';
    return clonePoints(JOURNEY_POINTS_BY_BREAKPOINT[id]);
}

export function getDefaultPathSamples(breakpointId) {
    const id = JOURNEY_BREAKPOINTS[breakpointId] ? breakpointId : 'desktop';
    return cloneSamples(JOURNEY_PATH_SAMPLES_BY_BREAKPOINT[id]);
}

/** Normalize stored override entry (supports legacy array-only format). */
function normalizeOverrideEntry(entry, breakpointId) {
    const fallbackPoints = JOURNEY_POINTS_BY_BREAKPOINT[breakpointId];
    if (Array.isArray(entry)) {
        return {
            points: normalizePoints(entry, fallbackPoints),
            pathSamples: null,
        };
    }
    if (entry && typeof entry === 'object') {
        return {
            points: normalizePoints(entry.points, fallbackPoints),
            pathSamples: cloneSamples(entry.pathSamples),
        };
    }
    return {
        points: clonePoints(fallbackPoints),
        pathSamples: getDefaultPathSamples(breakpointId),
    };
}

export function readStoredOverrides() {
    if (!isJourneyDevAvailable()) return {};
    try {
        const raw = window.localStorage?.getItem(OVERRIDES_KEY);
        // migrate legacy key if present
        const legacy = window.localStorage?.getItem(
            'dv2JourneyPointsByBreakpoint'
        );
        const source = raw || legacy;
        if (!source) return {};
        const parsed = JSON.parse(source);
        if (!parsed || typeof parsed !== 'object') return {};
        const out = {};
        Object.keys(JOURNEY_BREAKPOINTS).forEach((id) => {
            if (parsed[id]) {
                out[id] = normalizeOverrideEntry(parsed[id], id);
            }
        });
        return out;
    } catch {
        return {};
    }
}

export function writeStoredOverrides(overrides) {
    if (!isJourneyDevAvailable()) return;
    try {
        window.localStorage?.setItem(
            OVERRIDES_KEY,
            JSON.stringify(overrides || {})
        );
    } catch {
        /* ignore */
    }
}

export function clearStoredOverrides() {
    if (!isJourneyDevAvailable()) return;
    try {
        window.localStorage?.removeItem(OVERRIDES_KEY);
        window.localStorage?.removeItem('dv2JourneyPointsByBreakpoint');
    } catch {
        /* ignore */
    }
}

export function resolveJourneyBundle(breakpointId, overrides = {}) {
    const id = JOURNEY_BREAKPOINTS[breakpointId] ? breakpointId : 'desktop';
    if (overrides[id]) {
        return normalizeOverrideEntry(overrides[id], id);
    }
    return {
        points: getDefaultPoints(id),
        pathSamples: getDefaultPathSamples(id),
    };
}

/** Resolve active points: stored override for BP → defaults. */
export function resolveJourneyPoints(breakpointId, overrides = {}) {
    return resolveJourneyBundle(breakpointId, overrides).points;
}

export function resolvePathSamples(breakpointId, overrides = {}) {
    return resolveJourneyBundle(breakpointId, overrides).pathSamples;
}

/**
 * Smooth SVG path through an ordered list of {x,y} (already trailhead → summit).
 * Catmull-Rom → cubic Bézier.
 */
export function buildPathFromSamples(samples) {
    const pts = (samples || [])
        .map((m) => ({ x: Number(m.x), y: Number(m.y) }))
        .filter((p) => Number.isFinite(p.x) && Number.isFinite(p.y));
    if (pts.length < 2) return '';

    let d = `M ${pts[0].x} ${pts[0].y}`;
    for (let i = 0; i < pts.length - 1; i += 1) {
        const p0 = pts[i - 1] || pts[i];
        const p1 = pts[i];
        const p2 = pts[i + 1];
        const p3 = pts[i + 2] || p2;
        const c1x = p1.x + (p2.x - p0.x) / 6;
        const c1y = p1.y + (p2.y - p0.y) / 6;
        const c2x = p2.x - (p3.x - p1.x) / 6;
        const c2y = p2.y - (p3.y - p1.y) / 6;
        d += ` C ${c1x.toFixed(2)} ${c1y.toFixed(2)}, ${c2x.toFixed(
            2
        )} ${c2y.toFixed(2)}, ${p2.x} ${p2.y}`;
    }
    return d;
}

/**
 * Smooth SVG path through markers (trailhead → summit) when no freehand samples.
 */
export function buildJourneyPath(pointsByRank) {
    const pts = [...(pointsByRank || [])]
        .slice()
        .sort((a, b) => (b.rank || 0) - (a.rank || 0))
        .map((m) => ({ x: Number(m.x), y: Number(m.y) }));
    return buildPathFromSamples(pts);
}

export function buildActiveJourneyPath(pointsByRank, pathSamples) {
    if (Array.isArray(pathSamples) && pathSamples.length >= 2) {
        return buildPathFromSamples(pathSamples);
    }
    return buildJourneyPath(pointsByRank);
}

/** Thin a freehand stroke by min distance in % space. */
export function simplifyStroke(points, minDist = 0.6, maxPoints = 64) {
    if (!Array.isArray(points) || points.length < 2) {
        return Array.isArray(points) && points.length
            ? points.map((p) => ({
                  x: roundCoord(p.x),
                  y: roundCoord(p.y),
              }))
            : null;
    }
    const out = [{ x: points[0].x, y: points[0].y }];
    for (let i = 1; i < points.length; i += 1) {
        const prev = out[out.length - 1];
        const cur = points[i];
        const dx = cur.x - prev.x;
        const dy = cur.y - prev.y;
        if (Math.hypot(dx, dy) >= minDist) {
            out.push({ x: cur.x, y: cur.y });
        }
    }
    const last = points[points.length - 1];
    const tip = out[out.length - 1];
    if (tip.x !== last.x || tip.y !== last.y) {
        out.push({ x: last.x, y: last.y });
    }
    // Always keep endpoints even if stroke was short
    if (out.length < 2) {
        out.push({ x: last.x, y: last.y });
    }
    if (out.length <= maxPoints) return cloneSamples(out);

    const step = (out.length - 1) / (maxPoints - 1);
    const resampled = [];
    for (let i = 0; i < maxPoints; i += 1) {
        const idx = Math.round(i * step);
        resampled.push(out[idx]);
    }
    return cloneSamples(resampled);
}

function polylineLength(samples) {
    let total = 0;
    for (let i = 1; i < samples.length; i += 1) {
        total += Math.hypot(
            samples[i].x - samples[i - 1].x,
            samples[i].y - samples[i - 1].y
        );
    }
    return total;
}

/** Point at arc-length fraction t ∈ [0,1] along samples. */
export function pointAlongSamples(samples, t) {
    if (!samples?.length) return { x: 50, y: 50 };
    if (samples.length === 1) return { ...samples[0] };
    const target = Math.min(1, Math.max(0, t)) * polylineLength(samples);
    let walked = 0;
    for (let i = 1; i < samples.length; i += 1) {
        const a = samples[i - 1];
        const b = samples[i];
        const seg = Math.hypot(b.x - a.x, b.y - a.y);
        if (walked + seg >= target || i === samples.length - 1) {
            const u = seg === 0 ? 0 : (target - walked) / seg;
            return {
                x: roundCoord(a.x + (b.x - a.x) * u),
                y: roundCoord(a.y + (b.y - a.y) * u),
            };
        }
        walked += seg;
    }
    return { ...samples[samples.length - 1] };
}

/**
 * Place ranks along a trail (0 = trailhead, 1 = summit).
 * Preserves side / type from existing points. Rank 7 at start, rank 1 at end.
 */
export function placeMarkersAlongPath(existingPoints, pathSamples) {
    const samples = cloneSamples(pathSamples);
    if (!samples || samples.length < 2) return clonePoints(existingPoints);
    const base = clonePoints(existingPoints);
    const ranks = base.map((p) => p.rank);
    const maxRank = Math.max(...ranks);
    const minRank = Math.min(...ranks);
    const span = maxRank - minRank || 1;
    return base.map((p) => {
        const along = (maxRank - p.rank) / span;
        const pt = pointAlongSamples(samples, along);
        return { ...p, x: pt.x, y: pt.y };
    });
}

export function formatPointsExport(overridesOrMap) {
    const payload = {
        note:
            'Paste points into JOURNEY_POINTS_BY_BREAKPOINT and pathSamples into JOURNEY_PATH_SAMPLES_BY_BREAKPOINT in journeyPointsConfig.js',
        viewportWidth:
            typeof window !== 'undefined' ? window.innerWidth : undefined,
        exportedAt: new Date().toISOString(),
        pointsByBreakpoint: {},
        pathSamplesByBreakpoint: {},
    };
    Object.keys(JOURNEY_BREAKPOINTS).forEach((id) => {
        const bundle = resolveJourneyBundle(id, overridesOrMap);
        payload.pointsByBreakpoint[id] = bundle.points;
        payload.pathSamplesByBreakpoint[id] = bundle.pathSamples;
    });
    return JSON.stringify(payload, null, 2);
}
